import { slimZeroPriceRows } from "@/mocks/slimZeroDetails";

/**
 * Medical Slim ZERO の公式サイト定価（1回）を表示する料金テーブル。
 * onlySlug を指定すると、該当する治療1件のみを表示する（各詳細ページ用）。
 * 新規お試しモニター価格は公式サイトには掲載しない。
 */
export default function SlimZeroPriceTable({ onlySlug }: { onlySlug?: string }) {
  const rows = onlySlug ? slimZeroPriceRows.filter((row) => row.slug === onlySlug) : slimZeroPriceRows;

  return (
    <div className="max-w-3xl">
      <div className="grid grid-cols-[1.6fr_1fr] border-t border-foreground-950/20 pb-3 pt-4 text-[11px] tracking-[0.15em] text-foreground-500">
        <span>対象</span>
        <span className="text-right">料金</span>
      </div>
      {rows.map((row) => (
        <div
          key={row.slug}
          className="grid grid-cols-[1.6fr_1fr] items-baseline border-t border-foreground-950/12 py-5"
        >
          <span className="pr-6">
            <span className="block font-heading text-[15px] text-foreground-950">{row.name}</span>
            <span className="mt-1 block text-[11.5px] leading-[1.8] text-foreground-500">{row.note}</span>
          </span>
          <span className="text-right font-label text-[15px] text-foreground-900">{row.price}</span>
        </div>
      ))}
      <p className="mt-4 text-[12px] leading-[2] text-foreground-500">表示価格はすべて税込です。</p>
    </div>
  );
}